module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-BOOSTER-GREEN-2.5a319901.jpg";